import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    detailChannel = new Subject();
    repository = new CreateRepository()
    listPegawaiChanel = new Subject()
    listHukumanChanel = new Subject()
  
    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPegawai = async (query) => {
        this.listPegawaiChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchPegawai(query).then((result) => {
            this.listPegawaiChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.listPegawaiChanel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchHukuman = async (query) => {
        this.listHukumanChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchHukuman(query).then((result) => {
            this.listHukumanChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.listHukumanChanel.next({status: apiResponse.ERROR, data: error})
        })
    }

    
}

export default CreateBloc